// store/useAuthStore.ts
import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';
import { authInitialState } from './authInitialState';
import { createAuthSlice } from './createAuthSlice';
import type { AuthActions } from './createAuthSlice';
import type { AuthState } from './authInitialState';

/**
 * @french
 * Hook Zustand persistant pour l’authentification.
 */
export const useAuthStore = create<AuthState & AuthActions>()(
  persist(combine(authInitialState, createAuthSlice as any), {
    name: 'auth-store', // clé pour localStorage / sessionStorage
  }),
);
